/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { EditIcons } from "./EditIcons";
interface TooltipContainerProps {
  onClose: () => void;
  children: React.ReactNode;
}
export const ToolTipContainer = ({
  onClose,
  children,
}: TooltipContainerProps) => {
    const toolTipRef = React.useRef<HTMLDivElement>(null);
     React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent | TouchEvent) => {
          // If the dropdownRef exists and the click target is not within it, close the dropdown
          if (toolTipRef.current && !toolTipRef.current.contains(event.target as Node)) {
            onClose();
          }
        };
        // Add event listeners for both mouse and touch events
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);    
        // Cleanup event listeners on unmount
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
          document.removeEventListener('touchstart', handleClickOutside);
        };
      }, []);
      
  return (
    <div
      ref={toolTipRef}
      style={{
        position: "absolute",
        top: "100%",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "rgb(53, 59, 72)",
        color: "white",
        padding: "8px 12px",
        borderRadius: "4px",
        zIndex: 10,
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        width: 245,
        wordWrap: "break-word",
        whiteSpace: "normal",
        textOverflow: "ellipsis",
      }}
    >
      <div
        style={{
          position: "absolute",
          bottom: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          width: "0",
          height: "0",
          borderLeft: "6px solid transparent",
          borderRight: "6px solid transparent",
          borderBottom: "6px solid rgb(53, 59, 72)",
        }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        <div
          style={{
            width: "100%",
            borderBottom: "1px solid white",
            display: "flex",
            flexDirection: "column",
            marginBottom: "2px",
          }}
        >
          <div
            onClick={onClose}
            style={{ cursor: "pointer", alignSelf: "flex-end" }}
          >
            <EditIcons.CrossIcon height="20px" width="20px" fill="white" />
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};
